<div class="print-history-popup" style="background-image: none; box-shadow: none" *ngIf="askSendSMS">
  <div class="t-popup-close"></div>

  <div class="t-popup-frame">
    <div class="t-popup-body">
      <button
        class="t-btn-popup-close"
        aria-label="close popup"
        [disabled]="creatingPending"
        (click)="askSendSMS = false; error = ''"
      ></button>

      <h2 *ngIf="!sendUpdateSMS" style="color: #d7a95b">
        {{ !creatingPending ? " Do you wish to send an SMS to the patient?" : "Sending" }}
      </h2>
      <h2 *ngIf="sendUpdateSMS" style="color: #d7a95b">
        Send SMS with appointment changes?
      </h2>

      <div
        class="l-flex l-flex-w t-fieldmargin patient-details"
        style="align-items: center; display: flex; justify-content: center"
      >
        <mat-spinner
          *ngIf="creatingPending"
          diameter="18"
          strokeWidth="3"
          class="spinner-white"
          style="margin-right: 0.75rem"
        >
        </mat-spinner>

        <div *ngIf="sent && !creatingPending" style="font-weight: 600">
          {{ "GUI.Links.Sent" | translate }}
        </div>

        <div *ngIf="error && !creatingPending" style="color: #d9534f; font-weight: 600">
          {{ error }}
        </div>
      </div>

      <!-- Buttons - Creating a New Appointment (Start) -->
      <ng-container *ngIf="!sendUpdateSMS">
      
        <div class="l-flex l-flex-w t-fieldmargin patient-details"
          style="gap: 0.75rem; display: flex; justify-content: space-evenly">
          <button class="search-btn" style="width: 6em" [disabled]="creatingPending || sent" (click)="saveAppointment(true)">
            {{ "GUI.Links.Send" | translate }}
          </button>
      
          <button class="search-btn" style="width: 6em; background: #888" [disabled]="creatingPending"
            (click)="askSendSMS = false; saveAppointment(false)">
            {{ "appointments.gui.buttons.No" | translate | titlecase }}
          </button>
        </div>

      </ng-container>
      <!-- Buttons - Creating a New Appointment (End) -->

      <!-- Buttons - Updating an Appointment (Start) -->
      <ng-container *ngIf="sendUpdateSMS">
      
        <div class="l-flex l-flex-w t-fieldmargin patient-details"
          style="gap: 0.75rem; display: flex; justify-content: space-evenly">
          <button class="search-btn" style="width: 6em" [disabled]="creatingPending || sent" (click)="sendSMS(undefined, undefined, true)">
            {{ "GUI.Links.Send" | translate }}
          </button>
      
          <button class="search-btn" style="width: 6em; background: #888" [disabled]="creatingPending"
            (click)="askSendSMS = false; closeAppointmentModal('reloadEvents')">
            {{ "appointments.gui.buttons.No" | translate | titlecase }}
          </button>
        </div>

      </ng-container>
      <!-- Buttons - Updating an Appointment (End) -->

    </div>
  </div>
</div>
<div *ngIf="showApptLengthError" class="print-history-popup">
  <div class="print-history-popup-body">
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
      <h3>
        {{ apptLengthErrorMsg }}
      </h3>
    </div>

    <button
      (click)="showApptLengthError = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>
<div *ngIf="setExtraDetails" class="print-history-popup" [formGroup]="appointmentForm">
  <div class="print-history-popup-body">
    <!-- <div *ngIf="isObs()" class="l-flex l-flex-c t-field t-field-pad">							
      <span class="t-validation-wrap l-fg1 w65" style="display: flex;">
          <label>
            
              {{ 'appointments.gui.labels.LMP' | translate }}:
          </label>
          <input formControlName="LMP" (dateChange)="checklmp(this.appointmentForm.get('LMP').value)" [matDatepicker]="lmppicker"  class="t-field-text w100" />
          <mat-datepicker style="z-index: 9999;" #lmppicker ></mat-datepicker>
          <div class="t-validation-message">
              <span>
              
                {{'appointments.gui.labels.Invalid LMP' | translate}}
              </span>
          </div>
          <img src="../../assets/icons/date.svg" (click)="lmppicker.open()" style='margin-left: -1.8em;'>

      </span>
      <i class="t-sep"></i>
 
      <span class="t-validation-wrap l-fg1 w35" style="display: flex;">
          <label>
            
              {{'appointments.gui.labels.GA' | translate}}:
          </label>
          <span style="font-weight: bolder;">
            {{lmpGA(appointmentForm.get('LMP').value)}}
          </span>
      </span> 
      <h3 *ngIf="lmpError" style="color: white;
      background-color: #277382;
      border: 1px solid black;"
  >lmp does not match exam type</h3>
  </div> -->
    <div *ngIf="isObs()" class="flex flex-wrap items-center" (dblclick)="reset('Fetus')">
      <div class="lgw-1_6 xlw-1_12 py-4">
        <!-- Fetus: -->
        {{ "appointments.gui.labels.Fetus" | translate }}:
      </div>

      <div class="flex flex-wrap lgw-5_6 xlw-11_12">
        <label class="t-label-top py-4">
          <input type="radio" name="Fetus" class="custom-check" formControlName="Fetus" [value]="1" />
          <i class="customInput-display"></i>
          <span>
            {{ "appointments.gui.labels.Singleton" | translate }}
          </span>
        </label>

        <label class="t-label-top py-4">
          <input type="radio" name="Fetus" class="custom-check" formControlName="Fetus" [value]="2" />
          <i class="customInput-display"></i>
          <span>
            {{ "appointments.gui.labels.Twins" | translate }}
          </span>
        </label>
      </div>
    </div>
    <div *ngIf="ls.isCardio" class="flex flex-wrap items-center" (dblclick)="reset('FundingDetails')">
      <div class="flex flex-wrap lgw-5_6 xlw-11_12">
        <label class="t-label-top py-4">
          <input
            type="radio"
            name="FundingDetails"
            class="custom-check"
            formControlName="FundingDetails"
            value="private"
          />
          <i class="customInput-display"></i>
          <span>
            {{ "appointments.gui.labels.Private" | translate }}
          </span>
        </label>

        <label class="t-label-top py-4">
          <input
            type="radio"
            name="FundingDetails"
            class="custom-check"
            formControlName="FundingDetails"
            value="expatriate"
          />
          <i class="customInput-display"></i>
          <span>
            {{ "appointments.gui.labels.expatriate" | translate }}
          </span>
        </label>
        <label class="t-label-top py-4">
          <input
            type="radio"
            name="FundingDetails"
            class="custom-check"
            formControlName="FundingDetails"
            value="other"
          />
          <i class="customInput-display"></i>
          <span>
            {{ "appointments.gui.labels.Other" | translate }}
          </span>
        </label>
      </div>
    </div>
    <button
      class="blue-btn"
      [matTooltip]="'appointments.gui.tooltips.Calculate Exam Price' | translate | titlecase"
      (click)="calculateAppointmentPrice()"
    >
      <!-- Calculate price -->
      {{ "appointments.gui.buttons.Calculate Price" | translate }}
    </button>
    <div *ngIf="calculatedPrice" style="display: flex; flex-direction: row; align-items: center">
      <h3>
        <!-- the price is: -->
        {{ "appointments.gui.labels.the price is" | translate }}
        {{ calculatedPrice }}
      </h3>
      <button class="blue-btn" (click)="setPrice()">
        <!-- Set Price -->
        {{ "appointments.gui.buttons.Set Price" | translate }}
      </button>
      <button class="orange-btn" (click)="setExtraDetails = false">
        <!-- Close -->
        {{ "appointments.gui.buttons.Close" | translate }}
      </button>
    </div>

    <button
      (click)="setExtraDetails = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>
<div class="t-popup popup-patientDetails" [formGroup]="appointmentForm">
  <div class="t-popup-close"></div>
  <div
    class="t-popup-frame"
    style="display: flex; flex-direction: column; margin-top: 0"
    cdkDrag
    cdkDragBoundary=".t-popup"
  >
    <div *ngIf="!event" style="display: flex; width: 50%; float: right; cursor: grab" cdkDragHandle>
      <button class="search-btn" style="background-color: #6d7cab00; cursor: grab">
        {{ "appointments.gui.labels.Select Patient" | translate | titlecase }}
      </button>
      <img class="w10" src="assets/images/arr-right.svg" />
      <button class="search-btn" style="background-color: #6d7cab00; cursor: grab">
        {{ "appointments.gui.labels.Patient Details" | translate | titlecase }}
      </button>
      <img class="w10" src="assets/images/arr-right.svg" />
      <button
        class="search-btn"
        style="background-color: #6d7cab00; color: #277382; font-weight: 700; cursor: grab"
      >
        {{ "appointments.gui.labels.Set Appointment" | translate | titlecase }}
      </button>
    </div>
    <button
      *ngIf="!event"
      class="t-btn-popup-close"
      aria-label="close popup"
      (click)="closeAppointmentModal(false)"
    ></button>
    <div class="t-popup-body">
      <button
        *ngIf="event"
        class="t-btn-popup-close"
        aria-label="close popup"
        (click)="closeAppointmentModal(false)"
      ></button>
      <div style="display: flex">
        <div style="display: flex; flex-direction: column; width: 50%">
          <h2 style="cursor: grab" cdkDragHandle>
            {{ event ? "" : ("appointments.gui.labels.Set" | translate) }}
            {{ "appointments.gui.labels.Appointment Details" | translate | titlecase }}
          </h2>
          <h4 *ngIf="event && event.CreatedByPID">
            {{ "appointments.gui.labels.made by patient" | translate | titlecase }}
          </h4>
        </div>

        <div *ngIf="!appointmentsByRooms && ls.clinicUsers" style="width: 40%">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label matTooltip="שם הרופא">
              <img src="../../assets/icons/drb.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <select
                formControlName="UID"
                class="t-select w100"
                style="text-align: center"
                (change)="onDoctorChange($event)"
              >
                <!-- <option [ngValue]="null">All</option> -->
                <ng-container *ngFor="let e of getDoctors()">
                  <option [value]="e.UID">{{ e.Name }}</option>
                </ng-container>
              </select>
            </span>
          </div>
        </div>
        <!-- ======== Room Selection (Start) ========-->
        <div *ngIf="appointmentsByRooms" style="width: 40%">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label matTooltip="שם החדר">
              <img src="../../assets/icons/room-blue.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <select
                formControlName="RID"
                class="t-select w100"
                style="text-align: center"
                (change)="onRoomChange($event)"
              >
                <ng-container *ngFor="let r of ls.activeRooms">
                  <option [value]="r.AutoIndex">{{ r.RoomName }}</option>
                </ng-container>
              </select>
            </span>
          </div>
          <!-- ======== Room Selection (End) ========-->
        </div>
      </div>
      <!-- Patient Name -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap">
              {{ "appointments.gui.labels.Patient Name" | translate | titlecase }}
            </label>
            <i class="t-sep"></i>
            <input type="text" class="t-field-text w100" formControlName="patientName" />
          </div>
        </div>
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap">
              {{ "appointments.gui.labels.Patient Mobile" | translate | titlecase }}
            </label>
            <i class="t-sep"></i>
            <input type="text" class="t-field-text w100" formControlName="patientMobile" />
          </div>
        </div>
      </div>

      <!-- Exam Date Display Only, Consider Adding an Input for Actual Date Selection -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap">
              {{ "appointments.gui.labels.ID" | translate | titlecase }}
            </label>
            <i class="t-sep"></i>
            <input type="text" class="t-field-text w100" formControlName="ID" />
          </div>
        </div>
        <div *ngIf="ls.isObgyn" class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <span class="t-validation-wrap l-fg1 w65" style="display: flex">
              <label style="width: 80%">
                <!-- LMP: -->
                {{ "appointments.gui.labels.LMP" | translate }}
              </label>
              <input
                formControlName="LMP"
                (dateChange)="checklmp(this.appointmentForm.get('LMP').value)"
                [matDatepicker]="lmppicker"
                class="t-field-text w100"
              />
              <mat-datepicker style="z-index: 9999" #lmppicker></mat-datepicker>
              <div class="t-validation-message">
                <span>
                  <!-- Invalid LMP -->
                  {{ "appointments.gui.labels.Invalid LMP" | translate }}
                </span>
              </div>
              <img
                src="../../assets/icons/date.svg"
                (click)="lmppicker.open()"
                style="margin-left: -1.8em"
              />
            </span>
            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1 w35" style="display: flex">
              <label>
                <!-- GA: -->
                {{ "appointments.gui.labels.GA" | translate }}:
              </label>
              <span style="font-weight: bolder">
                {{ lmpGA(appointmentForm.get("LMP").value) }}
              </span>
            </span>
            <!-- <h3 *ngIf="lmpError" style="color: white;
            background-color: #277382;
            border: 1px solid black;"
        >lmp does not match exam type</h3> -->
          </div>
        </div>
      </div>

      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap">
              {{ "appointments.gui.labels.Exam Date" | translate | titlecase }}
            </label>
            <i class="t-sep"></i>
            <div style="flex: 1; display: flex; align-items: center; gap: 0.5em; min-width: 0;">
              <input
                [matDatepicker]="appointmentDate"
                formControlName="appointmentDate"
                class="t-field-text"
              />
              <span *ngIf="appointmentForm.get('appointmentDate').value" style="font-weight: 600; white-space: nowrap;">
                {{ getDayOfWeek(appointmentForm.get('appointmentDate').value) }}
              </span>
              <img
                src="../../assets/icons/date.svg"
                (click)="appointmentDate.open()"
                style="cursor: pointer"
              />
              <img
                *ngIf="event"
                style="cursor: pointer"
                matTooltip="View full calendar"
                (click)="onDateChange($event)"
                src="../../assets/icons/event_upcoming_orange.svg"
              />
            </div>
            <mat-datepicker #appointmentDate startView="year"></mat-datepicker>
          </div>
        </div>
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap">
              <!-- Hour Selection -->
              {{ "appointments.gui.labels.Start Hour" | translate }}
            </label>
            <i class="t-sep"></i>
            <input type="time" class="t-field-text w100" formControlName="startHour" />
          </div>
        </div>
      </div>

      <!--  Funding -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <ng-template #payerSelect>
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Payer" | translate }}
            </label>
            <i class="t-sep"></i>
            <span class="t-validation-wrap l-fg1">
              <select
                formControlName="Payer"
                class="t-select w100"
                style="text-align: center"
              >
                <option [ngValue]="null"></option>
                <option *ngFor="let p of payers" [ngValue]="p">{{ payerMapping[p] }}</option>
              </select>
            </span>
          </div>
        </ng-template>
        <div
          class="w50"
          *ngIf="ls.premissions?.PayerPricing && !ls.premissions?.hmoAppointments"
        >
          <ng-container *ngTemplateOutlet="payerSelect"></ng-container>
        </div>
        <div
          class="flex flex-wrap items-center w50"
          *ngIf="ls.premissions && ls.premissions.hmoAppointments"
        >
          <!-- Payor -->
          <!-- <div class="lgw-1_6 xlw-1_12 py-4">
              {{ 'appointments.gui.labels.Payer' | translate }}
            </div> -->

          <ng-container *ngIf="ls.premissions?.PayerPricing">
            <ng-container *ngTemplateOutlet="payerSelect"></ng-container>
          </ng-container>
          <div class="flex flex-wrap lgw-5_6 xlw-11_12" *ngIf="!ls.premissions?.PayerPricing">
            <label class="t-label-top py-4">
              <input
                type="radio"
                name="Funding"
                class="custom-check"
                formControlName="Funding"
                value="Private"
              />
              <i class="customInput-display"></i>
              <span>
                <!-- Private -->
                {{ "appointments.gui.labels.Private" | translate }}
              </span>
            </label>

            <label class="t-label-top py-4">
              <input
                type="radio"
                name="Funding"
                class="custom-check"
                formControlName="Funding"
                value="Hmo"
              />
              <i class="customInput-display"></i>
              <span>
                <!-- HMO -->
                {{ "appointments.gui.labels.HMO" | translate }}
              </span>
            </label>
          </div>
          <!-- <h4 *ngIf="isHmoBalance()">{{'appointments.gui.labels.balance' | translate}}: {{this.hmoBalance}}</h4> -->
          <div style="display: flex; gap: 0.4em; margin-top: 0.25em; margin-bottom: 0.5em;">
            <div class="l-flex l-flex-c t-field" style="flex: 1; min-width: 0; padding: 0.2em 0.5em;">
              <input type="text" class="t-field-text w100" style="text-align: center; line-height: 1; padding: 0.35em 0.3em;"
                [value]="patientService.currentPatient?.HMO ? (settings.hmoMapping[patientService.currentPatient.HMO] || patientService.currentPatient.HMO) : ''"
                [placeholder]="patientService.currentPatient?.HMO ? '' : ('appointments.gui.labels.No Health Provider' | translate)"
                disabled />
            </div>
            <div class="l-flex l-flex-c t-field" style="flex: 1; min-width: 0; padding: 0.2em 0.5em;">
              <input type="text" class="t-field-text w100" style="text-align: center; line-height: 1; padding: 0.35em 0.3em;"
                [value]="patientService.currentPatient?.Insurance ? (settings.insuranceMapping[patientService.currentPatient.Insurance] || patientService.currentPatient.Insurance) : ''"
                [placeholder]="patientService.currentPatient?.Insurance ? '' : ('appointments.gui.labels.No Insurance' | translate)"
                disabled />
            </div>
          </div>
        </div>
        <div class="w50">
          <div [ngClass]="{ 'missing-field': isExamMissing, 'border-transition': true }"
          class="l-flex l-flex-c t-field t-field-pad">
            <div class="l-flex-c t-field t-twin-fieldset t-fieldset-big">
              <label [ngClass]="{ 'missing-label': isExamMissing, 'label-transition': true }">
                <input
                  type="radio"
                  name="custom"
                  class="custom-check"
                  formControlName="custom"
                  [value]="0"
                />
                <i class="customInput-display"></i>
                <span>
                  {{ "appointments.gui.labels.AWEB Exams" | translate }}
                </span>
              </label>

              <label [ngClass]="{ 'missing-label': isExamMissing, 'label-transition': true }">
                <input
                  type="radio"
                  name="custom"
                  class="custom-check"
                  formControlName="custom"
                  [value]="1"
                />
                <i class="customInput-display"></i>
                <span>
                  {{ "appointments.gui.labels.Other" | translate }}
                </span>
              </label>
            </div>
            <i class="t-sep"></i>
            <select
              *ngIf="!appointmentForm.get('custom').value"
              class="t-select w100"
              style="padding-left: 1vh"
              formControlName="examTypeID"
            >
              <option *ngFor="let e of this.examsTypes" [value]="e.AutoIndex">
                {{ e.examName }}
              </option>
            </select>
            <select
              *ngIf="appointmentForm.get('custom').value"
              class="t-select w100"
              style="padding-left: 1vh"
              formControlName="examTypeID"
            >
              <option *ngFor="let e of this.customExamTypes" [value]="e.AutoIndex">
                {{ e.examType }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w50" style="display: flex; gap: 2em; height: fit-content">
          <div class="l-flex l-flex-c t-field t-field-pad" style="max-width: fit-content">
            <label style="white-space: nowrap">
              {{ "appointments.gui.labels.Duration" | translate }}
            </label>
            <i class="t-sep"></i>
            <input type="text" class="t-field-text w100" formControlName="duration" />
            {{ "appointments.gui.labels.min" | translate }}
            <i class="t-sep"></i>
            <div *ngIf="ls.isObgyn" class="l-flex-c t-field t-twin-fieldset t-fieldset-big">
              <label>
                <input
                  type="radio"
                  name="time"
                  class="custom-check"
                  [(ngModel)]="timeSingleOrTwin"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="getApptLength($event)"
                  [value]="'single'"
                />
                <i class="customInput-display"></i>
                <span> {{ "appointments.gui.labels.Singleton" | translate }} </span>
              </label>

              <label>
                <input
                  type="radio"
                  name="time"
                  class="custom-check"
                  [(ngModel)]="timeSingleOrTwin"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="getApptLength($event)"
                  [value]="'twins'"
                />
                <i class="customInput-display"></i>
                <span> {{ "appointments.gui.labels.Twins" | translate }} </span>
              </label>
            </div>
          </div>
        </div>
        <!-- price -->
        <div
          class="l-flex l-flex-w t-fieldmargin patient-details w30"
          style="display: flex; justify-content: space-around"
        >
          <div>
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>
                {{ "appointments.gui.labels.Price" | translate }}
              </label>
              <i class="t-sep"></i>
              <input type="text" class="t-field-text w100" formControlName="Price" />
              {{ "appointments.gui.labels.NIS" | translate }}
            </div>
          </div>
        </div>
        <div class="w20">
          <button
            (click)="setExtraDetails = true"
            *ngIf="appointmentForm.get('Funding').value && appointmentForm.get('examTypeID').value"
            class="orange-btn"
            matTooltip=" "
          >
            {{ "appointments.gui.buttons.Cost Generator" | translate }}
          </button>
        </div>
      </div>

      <!-- Exam code (per HMO) -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details" *ngIf="availableCodes.length || appointmentForm.get('examCode').value">
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Exam Code" | translate }}
            </label>
            <select
              *ngIf="availableCodes.length > 1"
              class="t-field-text w100"
              formControlName="examCode"
            >
              <option [ngValue]="null">---</option>
              <option *ngFor="let code of availableCodes" [ngValue]="code">{{ code }}</option>
            </select>
            <input
              *ngIf="availableCodes.length <= 1"
              type="text"
              class="t-field-text w100"
              formControlName="examCode"
            />
          </div>
        </div>
      </div>

      <!-- Comments -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{ "appointments.gui.labels.Comments" | translate }}
            </label>
            <textarea class="t-field-text w100" formControlName="comment"></textarea>
          </div>
        </div>
      </div>
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w50" (dblclick)="reset('customColor'); selectedColor = null; dropdownOpen = false">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <div class="l-flex-c t-field t-twin-fieldset t-fieldset-big">
              <label>
                <span>
                  {{ "appointments.gui.labels.change appointment color" | translate }}
                </span>
              </label>
            </div>
            <i class="t-sep"></i>
            <div class="custom-dropdown">
              <div
                class="dropdown-selected"
                [ngStyle]="{
                  'background-color': selectedColor || '#fff',
                  color: selectedColor ? '#fff' : '#000'
                }"
                (click)="toggleDropdown()"
              >
                {{ !this.appointmentForm.get("customColor").value ? "" : "" }}
              </div>
              <div class="dropdown-options" *ngIf="dropdownOpen">
                <div
                  *ngFor="let color of customColors"
                  class="dropdown-option"
                  [ngStyle]="{ 'background-color': color, color: '#fff' }"
                  (click)="selectColor(color)"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div class="w50" style="display: flex; justify-content: center; align-items: center">
          <div style="display: flex; gap: 1em; direction: rtl">
            <strong matTooltip="מספר הפעמים שעודכן התאריך / מספר כלל התורים">
              שינויי תור: {{ totalChanges || 0 }} / {{ totalAppointments || 0 }}
            </strong>
            <!-- matTooltip="אישרו הגעה / ביטלו הגעה" -->
            <strong>
              אישור/ביטול הגעה: {{ confirmedArrivals || 0 }} / {{ canceledArrivals || 0 }}
            </strong>

            <strong matTooltip="מספר הפעמים שהמטופל אישר הגעה אך לא הופיע בפועל">
              אי הגעה לאחר אישור: {{ noShowAfterConfirmation || 0 }}
            </strong>
          </div>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div
          class="l-flex l-flex-w t-fieldmargin patient-details display"
          style="flex-wrap: inherit"
          [ngStyle]="{ direction: pageDirection }"
        >
          <ng-container *ngIf="ls.premissions && ls.premissions.SendSMSOnSave">
            <label class="t-label-top" style="gap: 0.5em" [class.opacity-50]="isSmsDisabledByConsent">
              <input type="radio" formControlName="SendSMS" [value]="true" [disabled]="isSmsDisabledByConsent" class="custom-check -sq" />
              <i
                class="customInput-display -sq"
                [style.cursor]="isSmsDisabledByConsent ? 'not-allowed' : 'pointer'"
                (dblclick)="!isSmsDisabledByConsent && appointmentForm.get('SendSMS').setValue(false)"
              ></i>
              <span>
                {{ "appointments.gui.labels.Send SMS Now" | translate }}
              </span>
            </label>
          </ng-container>
          <ng-container *ngIf="ls.premissions && ls.premissions.SMSReminders">
            <label
              class="t-label-top"
              style="gap: 0.5em"
              [class.opacity-50]="isSmsDisabledByConsent"
              (dblclick)="!isSmsDisabledByConsent && appointmentForm.get('ScheduleSMS').setValue(false)"
            >
              <input
                type="radio"
                formControlName="ScheduleSMS"
                [value]="true"
                [disabled]="isSmsDisabledByConsent"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq" [style.cursor]="isSmsDisabledByConsent ? 'not-allowed' : 'pointer'"></i>
              <span>
                {{ "appointments.gui.labels.Send SMS Reminder two days before" | translate }}
              </span>
            </label>
          </ng-container>

          <ng-container *ngIf="ls.premissions && ls.premissions.surveyLink">
            <label
              *ngIf="appointmentForm.get('completed').value === true"
              class="t-label-top"
              style="gap: 0.5em"
              [class.opacity-50]="isSmsDisabledByConsent"
              (dblclick)="!isSmsDisabledByConsent && appointmentForm.get('surveyFormSMS').setValue(false)"
            >
              <input
                type="radio"
                formControlName="surveyFormSMS"
                [value]="true"
                [disabled]="isSmsDisabledByConsent"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq" [style.cursor]="isSmsDisabledByConsent ? 'not-allowed' : 'pointer'"></i>
              <span>
                {{ "appointments.gui.labels.Send survey form SMS" | translate }}
              </span>
            </label>
          </ng-container>
        <label class="t-label-top" style="gap: 0.5em;" *ngIf="appointmentForm.get('SmsConsent')?.value === false">
          <input type="checkbox" [checked]="true" [disabled]="true" class="custom-check -sq" />
          <i class="customInput-display -sq" style="cursor: default;"></i>
          <span>
            {{'appointments.gui.labels.Patient Refused SMS' | translate}}
          </span>
        </label>
        </div>
        <div
          class="l-flex l-flex-w t-fieldmargin patient-details display"
          style="flex-wrap: inherit"
          [ngStyle]="{ direction: pageDirection }"
        >
          <label class="t-label-top" style="gap: 0.5em">
            <input
              type="radio"
              formControlName="arrivalConfirm"
              [value]="true"
              class="custom-check -sq"
            />
            <i
              class="customInput-display -sq"
              (dblclick)="appointmentForm.get('arrivalConfirm').setValue(null)"
            ></i>
            <span>
              {{ "appointments.gui.labels.confirm Arrive" | translate | titlecase }}
            </span>
          </label>
          <label class="t-label-top" style="gap: 0.5em">
            <input
              type="radio"
              formControlName="patientArrived"
              [value]="true"
              class="custom-check -sq"
            />
            <i
              class="customInput-display -sq"
              (dblclick)="appointmentForm.get('patientArrived').setValue(null)"
            ></i>
            <span> {{ "appointments.gui.labels.Patient Arrival" | translate }} </span>
          </label>

          <div class="cervical-row" style="padding-left: 2em; padding-right: 1em">
            <textarea
              class="l-textarea t-field--limitRad w100h100"
              placeholder="{{ 'appointments.gui.placeholders.no_appt_reason' | translate }}"
              formControlName="noExamReason"
            ></textarea>
          </div>
        </div>

        <div
          class="l-flex l-flex-w t-fieldmargin patient-details display"
          style="flex-wrap: inherit"
          [ngStyle]="{ direction: pageDirection }"
        >
          <label class="t-label-top" style="gap: 0.5em">
            <input
              type="radio"
              formControlName="patientArrived"
              [value]="false"
              class="custom-check -sq"
            />
            <i
              class="customInput-display -sq"
              (dblclick)="appointmentForm.get('patientArrived').setValue(null)"
            ></i>
            <span> {{ "appointments.gui.labels.Patient Not Arrived" | translate }}</span>
          </label>
          <label class="t-label-top" style="gap: 0.5em">
            <input type="radio" formControlName="completed" [value]="true" class="custom-check -sq" />
            <i
              class="customInput-display -sq"
              (dblclick)="appointmentForm.get('completed').setValue(null)"
            ></i>
            <span>
              {{ "appointments.gui.labels.app done" | translate }}
            </span>
          </label>
          <div class="cervical-row" style="padding-left: 2em; padding-right: 1em">
            <textarea
              class="l-textarea t-field--limitRad w100h100"
              placeholder="{{ 'appointments.gui.placeholders.no_pat_arrival' | translate }}"
              formControlName="patientNoArrivalReason"
            ></textarea>
          </div>
        </div>
      </div>
      <div
        *ngIf="!event"
        style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1em"
      >
        <button
          class="btn-cancel"
          [matTooltip]="'appointments.gui.tooltips.Cancel' | translate"
          (click)="closeAppointmentModal(false)"
        >
          {{ "appointments.gui.buttons.Cancel" | translate }}
        </button>
        <button
          class="btn-ok"
          [disabled]="creatingPending"
          [matTooltip]="'appointments.gui.tooltips.Save Appointment' | translate | titlecase"
          (click)="saveAppointment()"
          style="display: inline-flex; align-items: center; gap: 0.5rem"
        >
          <mat-spinner
            *ngIf="creatingPending"
            diameter="18"
            strokeWidth="3"
            class="login-loader"
          ></mat-spinner>
          <span *ngIf="!creatingPending">{{
            "appointments.gui.buttons.create new appointment" | translate
          }}</span>
        </button>

        <!-- <button *ngIf="isHmoBalanceValidAndfinished()"  class="btn-ok" [matTooltip]="'appointments.gui.tooltips.add to waiting list' | translate | titlecase" (click)="saveInWaitingList()"> -->
        <!-- waiting list  -->
        <!-- {{'appointments.gui.buttons.add to waiting list' | translate}} -->
        <!-- </button> -->
      </div>
      <div
        *ngIf="event"
        style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1em"
      >
        <button
          class="btn-cancel"
          [matTooltip]="'appointments.gui.tooltips.Delete Appointment' | translate | titlecase"
          (click)="showDeleteAlert = true"
        >
          <!-- Delete -->
          {{ "appointments.gui.buttons.Delete" | translate }}
        </button>

        <div *ngIf="showDeleteAlert" class="t-validation-wrap">
          <button class="t-menu-item is-invalid-left"></button>
          <div
            class="t-validation-message-left"
            style="width: 20em; left: -11em; top: -1.5em; font-size: medium"
          >
            <span style="border-radius: 8px">
              <p style="margin-bottom: 1em">
                {{ "appointments.gui.labels.confirm delete" | translate }}
              </p>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-left: 1vw;
                  margin-right: 1vw;
                "
              >
                <button class="t-menu-item" (click)="deleteAppointment()">
                  {{ "appointments.gui.buttons.Yes" | translate }}
                </button>
                <button class="t-menu-item" (click)="showDeleteAlert = false">
                  {{ "appointments.gui.buttons.No" | translate }}
                </button>
              </div>
            </span>
          </div>
        </div>
        <ng-container *ngIf="ls.premissions && ls.premissions.SMSReminders && isAppointmentIn1to2Days()">
          <div *ngIf="scheduleSmsPending" style="display: inline-flex; align-items: center;">
            <mat-spinner diameter="28" strokeWidth="3" class="spinner-white"></mat-spinner>
          </div>
          <img
            *ngIf="!scheduleSmsPending"
            [ngClass]="isSmsDisabledByConsent ? 'disabled' : 'enabled'"
            [class.opacity-50]="isSmsDisabledByConsent"
            [attr.aria-disabled]="isSmsDisabledByConsent ? true : null"
            [matTooltip]="isSmsDisabledByConsent ? 'Patient declined SMS messages' : 'Send 2-day reminder SMS now'"
            (click)="!isSmsDisabledByConsent && sendScheduleReminder()"
            [style.cursor]="isSmsDisabledByConsent ? 'not-allowed' : 'pointer'"
            height="41em"
            width="41em"
            src="../../assets/icons/calendar_clock_blue.svg"
          />
        </ng-container>

        <ng-container *ngIf="ls.premissions && ls.premissions.ManualSMS">
          <div *ngIf="smsPending; else smsIcon" class="sms-spinner-box">
            <mat-spinner diameter="28" strokeWidth="3" class="spinner-white"></mat-spinner>
          </div>

          <ng-template #smsIcon>
            <img
              [ngClass]="(smsDisabled || isSmsDisabledByConsent) ? 'disabled' : 'enabled'"
              [class.opacity-50]="smsDisabled || isSmsDisabledByConsent"
              [attr.aria-disabled]="(smsDisabled || isSmsDisabledByConsent) ? true : null"
              [matTooltip]="smsDisabled ? 'Cannot send SMS for a past appointment' : (isSmsDisabledByConsent ? 'Patient declined SMS messages' : 'Send SMS')"
              (click)="!(smsDisabled || isSmsDisabledByConsent) && startManualSms()"
              [style.cursor]="(smsDisabled || isSmsDisabledByConsent) ? 'not-allowed' : 'pointer'"
              height="41em"
              width="41em"
              src="../../assets/icons/share-blue.svg"
            />
          </ng-template>
        </ng-container>
        <img
          *ngIf="ls.premissions?.Billings && patientService.currentPatient"
          style="cursor: pointer"
          [matTooltip]="'appointments.gui.tooltips.Patient Billing' | translate | titlecase"
          (click)="goBillingsPatient(patientService.currentPatient)"
          height="41em"
          width="41em"
          src="../../assets/icons/billings-blue.svg"
        />
        <img
          *ngIf="ls.premissions?.Appointments && patientService.currentPatient"
          style="cursor: pointer"
          [matTooltip]="'billing.gui.tooltips.Patient Appointments' | translate | titlecase"
          (click)="goAppointmentsPatient(patientService.currentPatient)"
          height="41em"
          width="41em"
          src="../../assets/icons/calendar-blue.svg"
        />
        <button
          class="btn-ok"
          [matTooltip]="'appointments.gui.tooltips.Update Appointments Details' | translate | titlecase"
          (click)="updateAppointment()"
        >
          {{ "appointments.gui.buttons.Close & Update" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
